import { inject } from "@angular/core";
import { ActivatedRouteSnapshot, CanActivateFn, Router, UrlTree } from "@angular/router";
import { ConnectivityService } from "@shared/services/connectivity/connectivity.service";
import { CustomToastService } from "@shared/services/custom-toast/custom-toast.service";
import { DownloadRecordsService } from "@shared/services/offline/download-records.service";
import { SessionUserDataService } from "@shared/services/user-data/session-user-data.service";

export const OnlineOrDownloadedGuard: CanActivateFn = async (route: ActivatedRouteSnapshot): Promise<boolean | UrlTree> => {
  if (inject(ConnectivityService).isConnected()) return true;

  const router: Router = inject(Router);
  const toast: CustomToastService = inject(CustomToastService);
  const downloadRecords: DownloadRecordsService = inject(DownloadRecordsService);
  const uid: string | null = inject(SessionUserDataService).storedUid();

  if (uid && (await downloadRecords.get(uid, Number(route.paramMap.get("courseId"))))) return true;

  toast.show({ message: "courseDownload.notDownloaded", type: "warning" });
  return router.navigated ? false : router.parseUrl("/");
};
